import ForwardDate, {SHIP_DATE_VALID_SHIPPER_TYPES} from './ForwardDate.js'
import {
  defaultValidLabelPropertiesFunc,
  ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

/**
 * Ship date for label config
 *
 * @param {Object} props
 * @param {String} props.label
 * @param {Boolean} [props.nextBusinessDay]
 * @returns {React.ReactNode}
 */
export default function ShipDate({
  label = 'Ship Date',
  nextBusinessDay = false,
}) {
  const propertySpecs = ShipDate.propertySpecList[0]

  return (
    <ForwardDate
      label={label}
      nextBusinessDay={nextBusinessDay}
      propertySpecs={propertySpecs}
    />
  )
}

ShipDate.propertySpecList = [
  {
    validShipperTypes: SHIP_DATE_VALID_SHIPPER_TYPES,
    labelPropertiesFunc: () => ['ship_date'],
    dependentPropertiesFunc: ADDITIONAL_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
